import React from 'react';
import { parseJson, splitProp, MuiProvider, getThemeType } from '@guest-widgets/core';
import { classes } from '@guest-widgets/shared/src/classes';
import { ErrorBoundaryWrapper, APMInit } from '@guest-widgets/shared/src/components/ErrorBoundary';
import { mapToLocation } from '@guest-widgets/shared/src/mappers/mapToLocation';

import { App, AppProps } from './App/App';

export interface CatalogWidgetWebComponentProps
  extends Omit<
    AppProps,
    'categoryFilter' | 'locationFilter' | 'disableFeatures' | 'enableFeatures' | 'configuration'
  > {
  categoryFilter?: string;
  locationFilter?: string;
  disableFeatures?: string;
  enableFeatures?: string;
  configuration?: string;
  /* disable download fonts */
  dataDisableFont?: string;
}

APMInit();

export const CatalogWidgetWebComponent = ({
  categoryFilter,
  locationFilter,
  disableFeatures,
  enableFeatures,
  configuration,
  ...rest
}: CatalogWidgetWebComponentProps) => {
  const listEnableFeatures = splitProp(enableFeatures);
  const disableDownloadFont = rest.dataDisableFont === 'true';

  return (
    <ErrorBoundaryWrapper>
      <MuiProvider
        classNamePrefix={classes.catalog.prefix}
        themeType={getThemeType(listEnableFeatures)}
      >
        <App
          {...rest}
          disableDownloadFont={disableDownloadFont}
          disableFeatures={splitProp(disableFeatures)}
          enableFeatures={listEnableFeatures}
          categoryFilter={splitProp(categoryFilter)}
          locationFilter={mapToLocation(locationFilter)}
          configuration={parseJson(configuration)}
        />
      </MuiProvider>
    </ErrorBoundaryWrapper>
  );
};
